import {Breakpoints} from "./Breakpoints";
import Swiper from "swiper";

const swiperElements = document.querySelectorAll('.swiper-container-default')
swiperElements.forEach(swiperElement => {

    // Paramètre par défaut pour les slides
    const defaultParams = {
        slidesPerView: 'auto',
        spaceBetween: 20,
        loop: true,
        breakpoints: Breakpoints,
        autoplay: {
            disableOnInteraction : false
        }
    }

    // Récupère les data-attribut sur l'objet déclarant le swiper et créer un objet en fonction du nom des attribut
    const dataParams = Object.assign({}, swiperElement.dataset)
    if(dataParams.breakpoints)
    {
        dataParams.breakpoints = JSON.parse(dataParams.breakpoints)
    }

    /**
     * Déclenchement de swiper avec le comportement par défaut, avec un nombre d'élément automatique
     * et un espace de 20 pixels
     * @type {Swiper}
     */
    const swiper = new Swiper(swiperElement, Object.assign({}, defaultParams, dataParams));
})
